import { MODULE_NAME } from './constants/moduleConstants';
import createGemMeterStore from '@modules/gem-meter/store';
import { default as GemMeter } from './components/index.vue';
import {
  editElement,
  addElement,
  removeElement,
  handleElementAttrChanged,
  init,
  reRunInit,
  handleUpdateVisibility,
} from './GemMeterEngine/Engine/useGemMeterController';
import { convertRuleByAttrName } from './GemMeterEngine/Engine/useGemMeterHelper';
import useGemMeter from './composable/useGemMeter';
import usePage from './composable/usePage';
import { BuildColorAndIcon } from './utils';
import { emitTrackCompleteRateEvent } from './utils/event-bus/index';
import { MutationTypes } from './store/mutations';
import { registerStore } from '@modules/common';
import '@modules/feedback';
import { isLandingPage, commitPageRules } from './GemMeterEngine/Engine/useGemMeterStore';
import CHECK_LIST from './constants/rulesConstants';
export {
  editElement,
  addElement,
  removeElement,
  convertRuleByAttrName,
  useGemMeter,
  usePage,
  BuildColorAndIcon,
  handleElementAttrChanged,
  MODULE_NAME,
  emitTrackCompleteRateEvent,
  MutationTypes,
  init,
  reRunInit,
  handleUpdateVisibility,
  isLandingPage,
  CHECK_LIST,
  commitPageRules,
};
export * from './constants/domConstants';
registerStore(MODULE_NAME, { store: createGemMeterStore() });
export default GemMeter;
